import { CartItem } from "../types/cart";
import { InventoryList } from "../types/inventory";
import { Product } from "../types/product";
import { post } from "./fetch.core";

async function loadCartInventories(items: CartItem[], warehouseIds: string[]) {
  const productIds = items.map((i) => i.product.id);
  const productInventories = (await post<InventoryList[]>("/pos/product/listInventory", { productIds, warehouseIds })).data;

  const newItems = items.map((cartItem) => {
    //  @ts-ignore
    const { inventories } = productInventories.find((i) => i.productId == cartItem.product.id);
    const retailInventories = inventories.filter((i) => warehouseIds.includes(i.warehouseId));

    return {
      ...cartItem,
      inventories,
      retailInventories,
    };
  });

  return newItems;
}

async function loadProductInventories(products: Product[], warehouseIds: string[]) {
  const productIds = products.map((i) => i.id);
  const productInventories = (await post<InventoryList[]>("/pos/product/listInventory", { productIds, warehouseIds })).data;

  const transformedProducts = products.map((p) => {
    //  @ts-ignore
    const { inventories } = productInventories.find((i) => i.productId == p.id);
    const retailInventories = inventories.filter((i) => warehouseIds.includes(i.warehouseId));
    const quantity = retailInventories.reduce((t, c) => t + c.count, 0);

    return {
      ...p,
      inventories,
      quantity,
      retailInventories,
    };
  });

  return transformedProducts;
}

export async function listInventoryForWarehouses(productIds: string[], warehouseIds: string[]) {
  const ids = [...new Set(productIds.filter(Boolean))];
  const whIds = [...new Set(warehouseIds.filter(Boolean))];
  if (ids.length === 0 || whIds.length === 0) return [];
  const { data } = await post<InventoryList[]>("/pos/product/listInventory", { productIds: ids, warehouseIds: whIds });
  return data;
}

const posInventoryCore = {
  loadCartInventories,
  loadProductInventories,
};

export default posInventoryCore;
